/**
 * API: Klaviyo
 * -----------------------------------------------------------------------------
 * Provides a wrapper for the Klaviyo API.
 * - https://developers.klaviyo.com/en/reference/api-overview
 *
 * Payload must match the structure outlined in the link below:
 * - https://developers.klaviyo.com/en/reference/create_client_subscription
 */

/**
 * Subscribes a new email address to Klaviyo.
 *
 * @param {String} source - Source of form submission e.g. 'Footer newsletter'
 * @param {Object} dataAttributes - Object containing customer details e.g email
 * , first name, last name, phone number and location.
 * @returns {Promise}
 */
export default (source, dataAttributes) => {
  const { newsletterId, token, version } = cnvs.credentials.klaviyo
  const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${token}`
  const payload = {

    /**
     * Must use JSON.stringify() because of strict Klaviyo requirements.
     */
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: `${source}`,
          profile: {
            data: {
              type: 'profile',
              attributes: dataAttributes,
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: `${newsletterId}` } } },
      },
    }),
    headers: {
      revision: `${version}`,
      'content-type': 'application/json',
    },
    method: 'POST',
  }

  return new Promise((resolve) => {
    fetch(
      url,
      payload,
    )

      /**
       * Using response.text() as response.json() resulted in a SyntaxError due
       * to 'Unexpected end of JSON'.
       */
      .then(response => response.text())
      .then(response => resolve(response))
      .catch(error => console.error('Klaviyo API request failed', error))
  })
}
